import { useEffect, useState } from "react";
import { productRequest } from "./ProductRequest";
import { useNavigate, useParams } from "react-router-dom";
import "../../../css/Products/Product.css";
import ProductLoading from "./ProductLoading";
import { useTranslation } from "react-i18next";
import { addToShoppingCartRequest } from "./AddToShoppingCartRequest";
import { removeToShoppingCartRequest } from "./RemoveToShoppingCartRequest";

function Product({ theme }) {
  const { product_link } = useParams();

  const [data, setData] = useState([]);

  const [loadingStatus, setLoadingStatus] = useState(false);

  const [quantityInShoppingCart, setQuantityInShoppingCart] = useState(0);

  useEffect(() => {
    productRequest(
      product_link,
      setLoadingStatus,
      setData,
      setQuantityInShoppingCart,
    );
  }, []);

  const { t } = useTranslation();

  const navigate = useNavigate();

  const [addToShoppingCartRequestStatus, setAddToShoppingCartRequestStatus] =
    useState(false);

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>{t("Product")}</div>

      {loadingStatus ? (
        <ProductLoading theme={theme}></ProductLoading>
      ) : (
        <div className="contentDiv">
          <div className={`productUserDiv`}>
            {data[0]?.user[0].profile_image_url ? (
              <img
                src={data[0]?.user[0].profile_image_url}
                className="profileImageInProductDiv"
              ></img>
            ) : (
              <div>p</div>
            )}

            <div>{data[0]?.user[0].username}</div>

            {data[0]?.user[0].tick == true && (
              <img src="/icons/green_tick.png" className="tickImage"></img>
            )}
          </div>
          <div className="productImagesDiv">
            {data[0]?.images.map((image, index) => {
              return <img src={image} key={index}></img>;
            })}
          </div>

          <div className="productInfoDiv">
            <div className="">{data[0]?.name}</div>
            <div className="">{data[0]?.caption}</div>
            <div className="">{data[0]?.inventory}</div>

          <div className="">{data[0]?.price}{' '}{data[0]?.price_type}</div>

            <div className="hashtagsDiv">
              {data[0]?.hashtags?.map((hashtag, index) => {
                return <div key={index} className={`hashtagDiv ${theme}`}>{hashtag}</div>;
              })}
            </div>

            <div className={`addToShoppingCartDiv ${theme}`}>
              {addToShoppingCartRequestStatus ? (
                <img src="/icons/loading.png" className="icon rotate"></img>
              ) : quantityInShoppingCart == 0 ? (
                <button
                  className="addToCartButton"
                  onClick={() => {
                    addToShoppingCartRequest(
                      setQuantityInShoppingCart,
                      data[0]?.link,
                      setAddToShoppingCartRequestStatus,
                    );
                  }}
                >
                  {t("Add to Cart")}
                </button>
              ) : (
                <div className={`shoppingCartDivInPorduct ${theme}`}>
                  <div
                    className="linkDiv"
                    onClick={() => {
                      navigate("/shopping_cart");
                    }}
                  >
                    {t("It is your shopping cart")}
                    <img src="/icons/link.png"></img>
                  </div>

                  <div className="inventoryShoppingCartDiv">
                    {" "}
                    <div>{quantityInShoppingCart}</div>
                    <button
                      className="shoppingCartSmallButton"
                      onClick={() => {
                        if (data[0]?.inventory > quantityInShoppingCart) {
                          addToShoppingCartRequest(
                            setQuantityInShoppingCart,
                            data[0]?.link,
                            setAddToShoppingCartRequestStatus,
                          );
                        }
                      }}
                    >
                      <img src="/icons/add.png"></img>
                    </button>
                    <button
                      className="shoppingCartSmallButton"
                      onClick={() => {
                        removeToShoppingCartRequest(
                          setQuantityInShoppingCart,
                          data[0]?.link,
                          setAddToShoppingCartRequestStatus,
                        );
                      }}
                    >
                      {quantityInShoppingCart == 1 ? (
                        <img src="/icons/delete.png"></img>
                      ) : (
                        <img src="/icons/reduce.png"></img>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Product;
